// extracted by mini-css-extract-plugin
export default {"modal":"YL-z","addItemButton":"ZL-z","plusCircle":"_L-z","branchVisible":"aM-z"};